function ScoreBadge({ score }: { score: number | null | undefined }) {
  if (score == null) return <span className="text-[var(--color-text-tertiary)]">—</span>;

  const color = score >= 85 ? 'text-green-500 border-green-500' :
    score >= 60 ? 'text-yellow-500 border-yellow-500' : 'text-red-500 border-red-500';

  return (
    <span className={`inline-flex items-center justify-center w-9 h-9 rounded-full border-2 font-mono text-xs font-bold ${color}`}>
      {score}
    </span>
  );
}

export { ScoreBadge };
